/* eslint-disable import/order */
import moment from 'moment'

import modalComponent from '@/modules/modal'
import { getAgreementsRegulation } from '@/services/RodoRegulations'
import RodoRegulations from '@/components/forms/RodoRegulations'

const $ = require('jquery')
require('../plugins/bootstrap/bootstrap-datetime')

const ajaxLoader = require('./ajaxLoader')
const { URL_API, BREAKPOINT } = require('./api')
const { EXPRESSIONS_DICTIONARY } = require('./dictionaries')
const { Loader } = require('./globals')

// ------------------------------------
// Order page
// ------------------------------------
const appGrecosPageOrder = {
  init () {
    this.orderOfferMarginTop()
    this.orderSessionTime()
    this.orderValidation()
    this.orderDatepicker()
    this.orderPaymentAgreement()
    this.orderParticipantFormMobile()
    this.orderParticipantMobileStyles()
    this.orderClearVoucherValue()
    this.orderShowPaymentOptions()
    this.orderRadioValueParticipantForm()
    this.orderFixedHeader()
    this.orderAdditionalServices()
    this.agreementsModal()
    this.rodoRegulations()
  },

  // ------------------------------------
  // Additional Services
  // ------------------------------------
  orderAdditionalServices () {
    const $wrapAdditionalServices = $('.additional-services')
    const $btnAdditionalServices = $wrapAdditionalServices.find('.services__btn')
    const $modalPlaceholder = $('#additional-services .modal__additional-services')
    const $boxAdditionalService = $('.services__tile')
    const countAdditionalServicesClassName = '.count-additional-services'
    const URLJson = URL_API.GetAdditionalServicesJSON + window.location.search

    $modalPlaceholder.empty()

    ajaxLoader.init({
      devTest: true,
      url: URLJson,
      method: 'GET',
      templateName: 'AdditionalServices',
      type: 'orderAdditionalServices',
      placeholder: $modalPlaceholder,
      beforeSendRequest () {
        $modalPlaceholder.append(Loader('small', 'white'))
        $('.additional-services .services__btn').addClass('services-loading')
        $('.additional-services .services__btn').append(Loader('small', 'white', false))
      },
      callback (servicesData) {
        log.debug(servicesData)
        $('.additional-services .services__btn').removeClass('disabled').addClass('modal-link')

        $btnAdditionalServices.on('click', function(e) {
          e.preventDefault()

          const buttonServicesType = $(this).parent().attr('data-typecode')

          const panelAccordionID = $('#accordion--additional-services')
          const panels = panelAccordionID.find('.panel')
          panels.each(function() {
            const panelTypeCode = $(this).data('typecode')
            if (panelTypeCode !== buttonServicesType) {
              $(this).hide()
            } else {
              $(this).show()
            }
          })

          const arrServices = []

          const formatNumber = function(n) {
            function f (c, i, a) {
              return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ` ${c}` : c
            }

            return n.toFixed(2).replace(/./g, f).replace('.00', '').replace('.', ',')
          }

          // --------------------------------------------
          // Create array of Additional Services
          $wrapAdditionalServices.find('.hidden input.ischecked').each(function() {
            const $this = $(this)
            const $thisParent = $this.parent()
            const getValue = $this.val()
            const getServiceCode = $thisParent.attr('data-servicecode')
            const objService = {
              Code: getServiceCode,
              Value: getValue,
            }
            arrServices.push(objService)
          })

          // --------------------------------------------
          // Set selected Additional Services
          const selected = 'true'
          for (let i = 0; i < arrServices.length; i++) {
            if (arrServices[i].hasOwnProperty('Value')) {
              if (arrServices[i].Value == selected) {
                const getServiceCode = arrServices[i].Code
                const setSelectedService = panelAccordionID.find(`.panel[data-servicescode="${getServiceCode}"]`)

                setSelectedService.addClass('selected')
                setSelectedService.find('button[role="button"]').text(EXPRESSIONS_DICTIONARY.delete).addClass('active')
              }
            }
          }

          const personData = $('.participant-form__content')
          // Two iteration variables because "serviceName" starts with id=1 and "personData.#People_" starts with id=0
          let personIter = 0
          let serviceIter = 1
          let serviceName = $(`.additional_services_person_${serviceIter}`)
          while (serviceName.length > 0) {
            const nameInput = personData.find(`#People_${personIter}__Name`)
            const surnameInput = personData.find(`#People_${personIter}__Surname`)
            const personFullName = `${nameInput.val()}<br/><b>${surnameInput.val()}</b>`
            serviceName.html(personFullName)
            personIter++
            serviceIter++
            serviceName = $(`.additional_services_person_${serviceIter}`)
          }

          const calculateSingleSerivcePrice = function() {
            const $this = $(this)
            const $closestPanel = $this.closest('.panel')

            const $checkedPersons = $closestPanel.find('input[type="checkbox"]:checked')
            let sumPrice = 0
            let sumAdultPrice = 0.0
            let sumChildrenPrice = 0.0
            let adultsCount = 0
            let childrenCount = 0

            $checkedPersons.each(function(i, el) {
              const personType = $(el).attr('data-personType')
              const personPrice = $(el).attr('data-price')

              if (personType === 'adult') {
                sumAdultPrice += Number(personPrice)
                adultsCount++
              }
              else {
                sumChildrenPrice += Number(personPrice)
                childrenCount++

              }

            })

            sumPrice = sumAdultPrice + sumChildrenPrice
            $closestPanel.find('.pricesAdult > b').html(formatNumber(sumAdultPrice))
            $closestPanel.find('.pricesChildren > b').html(formatNumber(sumChildrenPrice))
            $closestPanel.find('.price-sum .price > b').html(formatNumber(sumPrice))
            $closestPanel.find('.adults-count').html(`${adultsCount} dorośli`)
            $closestPanel.find('.children-count').html(`${childrenCount} dzieci`)
            return adultsCount + childrenCount
          }

          // --------------------------------------------
          // Select Persons
          const selectPersonsAdditionalServicesCheckboxes = $modalPlaceholder.find('.services-modal__tiles--square input[type="checkbox"]')
          if (!$._data(selectPersonsAdditionalServicesCheckboxes[0], 'events')) {
            selectPersonsAdditionalServicesCheckboxes
              .on('click', function() {
                const calculateSingleSerivcePriceForCheckboxClick = calculateSingleSerivcePrice.bind($(this))

                const $this = $(this)
                const $closestPanel = $this.closest('.panel')
                const serviceCode = $closestPanel.attr('data-servicescode')
                const serviceDiv = $(`.offerservice[data-servicecode=${serviceCode}]`)
                const serviceGroup = $closestPanel.attr('data-group')
                const serviceButton = $closestPanel.find('button[role="button"]')
                const penelSelectedClass = 'selected'

                if (calculateSingleSerivcePriceForCheckboxClick() != 0) {
                  $closestPanel.addClass(penelSelectedClass)
                  serviceButton.text(EXPRESSIONS_DICTIONARY.delete)

                  if ($closestPanel.hasClass(penelSelectedClass)) {
                    serviceDiv.find('.ischecked').attr('value', 'false')
                    $modalPlaceholder.find('.panel').each(function() {
                      const _serviceGroup = $(this).attr('data-group')
                      if (serviceGroup == _serviceGroup) {
                        $(this).not('.selected').find('button[role="button"]').not('.active').attr('disabled', 'disabled')

                        const $disabledButton = $(this).not('.selected').find('button[role="button"]').not('.active')
                        $disabledButton.closest('.services-modal__tile').find('input[type="checkbox"]').prop('disabled', true)
                      }
                    })
                  } else {
                    $modalPlaceholder.find('.panel').each(function() {
                      const _serviceGroup = $(this).attr('data-group')
                      if (serviceGroup == _serviceGroup) {
                        $(this).find('button[role="button"]').removeAttr('disabled')

                        const $button = $(this).find('button[role="button"]')
                        $button.closest('.services-modal__tile').find('input[type="checkbox"]').prop('disabled', false)
                      }
                    })
                  }
                } else {
                  $closestPanel.removeClass(penelSelectedClass)
                  serviceButton.text(EXPRESSIONS_DICTIONARY.choose)
                  $modalPlaceholder.find('.panel').each(function() {
                    const _serviceGroup = $(this).attr('data-group')
                    if (serviceGroup == _serviceGroup) {
                      $(this).find('button[role="button"]').removeAttr('disabled')

                      const $button = $(this).find('button[role="button"]')
                      $button.closest('.services-modal__tile').find('input[type="checkbox"]').prop('disabled', false)
                    }
                  })
                }
              })
          }

          // --------------------------------------------
          // Select Additional Service
          const selectAdditionalServicesButtons = $modalPlaceholder.find('.services-modal__content button[role="button"]')
          if (!$._data(selectAdditionalServicesButtons[0], 'events')) {
            selectAdditionalServicesButtons
              .on('click', function(e) {
                e.preventDefault()
                e.stopPropagation()

                const $this = $(this)
                const $closestPanel = $this.closest('.panel')
                const serviceCode = $closestPanel.attr('data-servicescode')
                const serviceDiv = $(`.offerservice[data-servicecode=${serviceCode}]`)
                const serviceGroup = $closestPanel.attr('data-group')
                const penelSelectedClass = 'selected'
                $closestPanel.toggleClass(penelSelectedClass)

                const checkboxexInPanel = $closestPanel.find('input[type="checkbox"]')

                if ($closestPanel.hasClass(penelSelectedClass)) {
                  $this.text(EXPRESSIONS_DICTIONARY.delete)
                  $this.addClass('active')
                  serviceDiv.find('.ischecked').attr('value', 'false')
                  $modalPlaceholder.find('.panel').each(function() {
                    const _serviceGroup = $(this).attr('data-group')
                    if (serviceGroup == _serviceGroup) {
                      $(this).find('button[role="button"]').not('.active').attr('disabled', 'disabled')

                      const $disabledButton = $(this).find('button[role="button"]').not('.active')
                      $disabledButton.closest('.services-modal__tile').find('input[type="checkbox"]').prop('disabled', true)
                    }
                  })
                  checkboxexInPanel.each(function(i, el) {
                    $(el).prop('checked', true)
                  })
                } else {
                  $this.text(EXPRESSIONS_DICTIONARY.choose)
                  $this.removeClass('active')
                  $modalPlaceholder.find('.panel').each(function() {
                    const _serviceGroup = $(this).attr('data-group')
                    if (serviceGroup == _serviceGroup) {
                      $(this).find('button[role="button"]').removeAttr('disabled')

                      const $button = $(this).find('button[role="button"]')
                      $button.closest('.services-modal__tile').find('input[type="checkbox"]').prop('disabled', false)
                    }
                  })
                  checkboxexInPanel.each(function(i, el) {
                    $(el).prop('checked', false)
                  })
                }

                const calculateSingleSerivcePriceForButtonClick = calculateSingleSerivcePrice.bind($this)
                calculateSingleSerivcePriceForButtonClick()
              })
          }

          // --------------------------------------------
          // Add Additional Services to order
          const confirmAdditionalServiceButton = $('#add-additional-services')
          if (!$._data(confirmAdditionalServiceButton[0], 'events')) {
            confirmAdditionalServiceButton.on('click', function(e) {
              e.preventDefault()
              e.stopPropagation()

              const priceVal = null
              const lenAddlServs = {}

              $('.payment-summary-price').html('')

              $.each($('.panel'), function() {
                const $this = $(this)
                const serviceCode = $this.data('servicescode')
                const serviceDiv = $(`.offerservice[data-servicecode=${serviceCode}]`)
                const titleText = serviceDiv.find('.title').val()

                const pricePerson = $this.data('serviceperperson')
                const pricePerDay = $this.data('serviceperday')
                const pricePercent = $this.data('servicepricepercent')
                const priceAdult = $this.data('servicepriceadult')
                const priceChild = $this.data('servicepricechild')
                const priceInfant = $this.data('servicepriceinfant')
                const priceTotal = $this.data('servicepricetotal')

                let selectedService = null
                for (let s = 0; s < servicesData.length; s++) {
                  if (servicesData[s].Code == serviceCode) {
                    selectedService = servicesData[s]
                  }
                }

                if (selectedService) {
                  const typeCode = $this.data('typecode')
                  if ('undefined' === typeof lenAddlServs[typeCode]) {
                    lenAddlServs[typeCode] = 0
                  }

                  if ($this.hasClass('selected')) {
                    lenAddlServs[typeCode]++

                    serviceDiv.find('.ischecked').attr('value', 'true').attr('data-servicepricetotal', priceVal)
                    let servicePeopleSelection = ''
                    let serviceAdultCount = 0
                    let serviceChildCount = 0
                    let serviceInfantCount = 0

                    $this.find('.person').each(function() {
                      const id = $(this).attr('id')
                      const checked = $(this).find('.selection').is(':checked')
                      const personType = $(this).find('.persontype').val()
                      if (checked) {
                        if (servicePeopleSelection != '') {
                          servicePeopleSelection = `${servicePeopleSelection}, `
                        }
                        servicePeopleSelection = servicePeopleSelection + id
                        if (personType == 'infant') {
                          serviceInfantCount++
                        } else if (personType == 'child') {
                          serviceChildCount++
                        } else {
                          serviceAdultCount++
                        }
                      }
                    })

                    serviceDiv.find('.person').val(servicePeopleSelection)

                    const objPriceVale = {
                      serviceCode,
                      servicePerPerson: pricePerson,
                      servicePerDay: pricePerDay,
                      servicePricePercent: pricePercent,
                      servicePriceTotal: parseFloat(priceTotal),
                      servicePriceAdult: parseFloat(priceAdult),
                      servicePriceChild: parseFloat(priceChild),
                      servicePriceInfant: parseFloat(priceInfant),
                      servicePeopleSelection,
                      serviceAdultCount,
                      serviceChildCount,
                      serviceInfantCount,
                      serviceTitle: titleText,
                    }

                    selectedService.Selection = objPriceVale

                  } else {
                    serviceDiv.find('.ischecked').attr('value', 'false')
                    selectedService.Selection = false
                  }
                }
              })

              for (const typeCode in lenAddlServs) {
                if (lenAddlServs[typeCode] > 0) {
                  $boxAdditionalService
                    .filter(`[data-typecode="${typeCode}"]`)
                    .addClass('selected')
                    .find(countAdditionalServicesClassName)
                    .html(lenAddlServs[typeCode])
                } else {
                  $boxAdditionalService
                    .filter(`[data-typecode="${typeCode}"]`)
                    .removeClass('selected')
                }
              }

              const defaultPriceVal = appGrecosPageOrder.defaultPriceObj().value

              $('.payment-summary-price').addClass('services-loading')
              $('.payment-summary-price').prepend(Loader('small', 'white', false))

              const postData = {}
              const query = window.location.search.substring('?')
              const queryParams = query.split('&')

              for (let i = 0; i < queryParams.length; i++) {
                const param = queryParams[i].split('=')
                const key = param[0].replace('?', '').replace('offercode', 'OfferId')
                const value = param[1]

                if (key && value) postData[key] = value
              }

              const ServiceDataRequests = $.map(servicesData, function(obj) {
                if (obj.Selection) {
                  const serviceObj = {
                    MerlinCode: obj.MerlinCode,
                    MerlinType: obj.MerlinType,
                    StartDate: obj.StartDate,
                    EndDate: obj.EndDate,
                    SelectedPeople: obj.Selection.servicePeopleSelection,
                  }
                  return serviceObj
                } else {
                  return null
                }
              })

              log.debug(ServiceDataRequests)
              postData.ServiceDataRequests = ServiceDataRequests

              $.post(URL_API.GetFinalPriceJSON, postData, function(response) {
                if (!response.totalPayment) {
                  $('.payment-summary-price').html('')
                  $('.payment-summary .price__full .btn').attr('disabled', true)
                  $('.payment-summary .price__full').addClass('hidden')
                  $('.payment-summary .price__error').removeClass('hidden')
                  return
                }

                $('.payment-summary .price__full .btn').attr('disabled', false)
                $('.payment-summary .price__full').removeClass('hidden')
                $('.payment-summary .price__error').addClass('hidden')

                $('.payment-summary-price').html(formatNumber(response.totalPayment))
                if (response.firstInstalment) {
                  $('.payment-summary-intalment').text(formatNumber(response.firstInstalment))
                }

                $('#payment-summary__additional-services li.dynamic').remove()
                $('#offer-insurrance li.dynamic').remove()

                let accumulatedPrice = defaultPriceVal
                let hasVarying = false

                for (let s = 0; s < servicesData.length; s++) {
                  const priceVal = servicesData[s].Selection
                  if (priceVal) {
                    if (priceVal.servicePricePercent) {
                      //Mozliwosc4: Ubezpieczenia - liczy sie zupelnie inaczej
                      hasVarying = true
                      continue
                    }
                    let totalServicePrice = 0
                    if (priceVal.servicePerPerson) {
                      //Mozliwosc2: Cena per osoba zamawiajace
                      const price =
                        priceVal.servicePriceAdult * priceVal.serviceAdultCount +
                        priceVal.servicePriceChild * priceVal.serviceChildCount +
                        priceVal.servicePriceInfant * priceVal.serviceInfantCount
                      totalServicePrice = price
                    } else {
                      if (priceVal.servicePerDay) {
                        //Mozliwosc3: Przedzial dat, przemnozenie ceny przez liczbe dni
                        //(EndDate - StartDate) * priceVal.servicePriceTotal
                      } else {
                        //Mozliwosc1: Cena za cala wycieczke
                        totalServicePrice = priceVal.servicePriceAdult
                        //TotalServicePrice = priceVal.servicePriceTotal;
                      }
                    }
                    accumulatedPrice = accumulatedPrice + totalServicePrice
                    totalServicePrice = formatNumber(totalServicePrice)
                    $('#payment-summary__additional-services ul').append(`<li id="service_${priceVal.serviceCode}" class="dynamic"><span class="pull-left">${priceVal.serviceTitle}</span><span class="summary-price">${totalServicePrice} <span class="f-gothamBook-normal">zł</span></span></li>`)
                    $('#offer-insurrance ul').append(`<li id="insurrance_${priceVal.serviceCode}" class="dynamic">${priceVal.serviceTitle}</li>`)
                  }
                }

                const totalPaymentVal = parseFloat(response.totalPayment)
                let remainingCost = totalPaymentVal - accumulatedPrice

                if (hasVarying) {
                  remainingCost = formatNumber(remainingCost)
                  let varCounter = 0
                  for (let s = 0; s < servicesData.length; s++) {
                    const priceVal = servicesData[s].Selection
                    if (priceVal) {
                      if (priceVal.servicePricePercent) {
                        varCounter++
                      }
                    }
                  }
                  for (let s = 0; s < servicesData.length; s++) {
                    const priceVal = servicesData[s].Selection
                    if (priceVal) {
                      if (priceVal.servicePricePercent) {
                        varCounter--
                        if (varCounter == 0) {
                          $('#payment-summary__additional-services ul').append(`<li id="service_${priceVal.serviceCode}" class="dynamic"><span class="pull-left">${priceVal.serviceTitle}</span><span class="summary-price">${remainingCost} <span class="f-gothamBook-normal">zł</span></span></li>`)
                        } else {
                          $('#payment-summary__additional-services ul').append(`<li id="service_${priceVal.serviceCode}" class="dynamic"><span class="pull-left">${priceVal.serviceTitle}</span><span class="summary-price"><span class="f-gothamBook-normal"></span></span></li>`)
                        }
                        $('#offer-insurrance ul').append(`<li id="insurrance_${priceVal.serviceCode}" class="dynamic">${priceVal.serviceTitle}</li>`)
                      }
                    }
                  }
                }
              })

              $('#additional-services .modal__close').click()
            })
          }
          $modalPlaceholder.find('.loader__inner').remove()
        })
      },
      afterSuccess () {
        $('.additional-services .services__btn').removeClass('services-loading')
        $('.additional-services .services__btn').find('.loader__inner').remove()
      },
    })
  },

  defaultPriceObj () {
    return {
      value: appGrecosPageOrder.defaultPriceValue(),
    }
  },
  defaultPriceValue () {
    let value = $('.payment-summary__info .price__full').find('input[type="hidden"]').val()

    value = value.replace(/\s/g, '')
    value = parseInt(value)

    return value
  },

  // ------------------------------------
  // time of session in order page
  // ------------------------------------
  orderSessionTime () {
    const counterTime = localStorage.getItem('sessionTimeout')
    let localValue = counterTime

    const timer = setInterval(function() {
      if (localValue > 0.1) {
        localValue -= 0.1
        if (localValue <= 0.1 && localValue > 0) {
          localValue = Math.floor(0)
        }
        const minutes = parseInt(localValue / 60)
        const seconds = parseInt(localValue % 60)
        $('.time-counter').text(
          `${minutes >= 10 ? minutes : `0${minutes}` 
          }:${
            seconds >= 10 ? seconds : `0${seconds}`}`
        )
        const progressValue = `${Math.round((counterTime - localValue) / counterTime * 10000) / 100}%`
        $('.session-progress__bar').css('width', progressValue)
      } else {
        clearInterval(timer)
        window.location.href = '/'
      }
    }, 100)
  },

  // ------------------------------------
  // Order: Validation
  // ------------------------------------
  orderValidation () {
    if (typeof $().validate !== 'undefined') {
      // Extend range validator method to treat checkboxes differently
      const defaultRangeValidator = $.validator.methods.range
      $.validator.methods.range = function(value, element, param) {
        if (element.type === 'checkbox' || element.type === 'radio') {
          // If it's a checkbox return true if it is checked
          return element.checked
        } else {
          // Otherwise run the default validation function
          return defaultRangeValidator.call(this, value, element, param)
        }
      }
    }
  },

  // ------------------------------------
  // Order: datepicker
  // ------------------------------------
  orderDatepicker () {
    const config = {
      viewMode: 'years',
      useCurrent: false,
      format: 'DD.MM.YYYY',
      extraFormats: [ 'yyyy-mm-dd', 'y-mm-dd' ],
      keepOpen: true,
      showClose: true,
      icons: {
        previous: 'fa fa-angle-left',
        next: 'fa fa-angle-right',
        close: 'custom-icon--cross',
      },
      toolbarPlacement: 'top',
      widgetPositioning: {
        horizontal: 'left',
        vertical: 'bottom',
      },
      minDate: moment().subtract(120, 'years').startOf('day').toDate(),
      maxDate: moment().subtract(10, 'years').endOf('day').toDate(),
    }

    function setTitleDatepicker () {
      if ($('.datepicker-title').length === 0) {
        $('.bootstrap-datetimepicker-widget').prepend(`<div class="datepicker-title">${EXPRESSIONS_DICTIONARY.chooseBirthday}</div>`)
      }
    }

    function setDefaultDateIfNotSelected (e) {
      const minDateAdultsSpan = config.maxDate.getTime()
      if (minDateAdultsSpan < e.date) {
        $(e.currentTarget).data('DateTimePicker').defaultDate(config.maxDate)
      }
    }

    const birthdayDatePicker = $('.datepicker--birthday.datepicker--adults')
    birthdayDatePicker.datetimepicker(config)
      .on('dp.show', setTitleDatepicker)
      .on('dp.hide', setDefaultDateIfNotSelected)
  },

  // ------------------------------------
  // Order: Payment Agreement
  // ------------------------------------
  orderPaymentAgreement () {
    const paymentAgreement = $('.payment-agreement')

    if (paymentAgreement.exists()) {
      $('.checkbox input[type="checkbox"]').on('change', function() {
        const _ = $(this)
        if (_.is(':checked')) {
          _.attr('checked', 'checked')
          _.val('true')
        } else {
          _.removeAttr('checked')
          _.val('false')
        }
      })
    }
  },

  // ------------------------------------
  // Participant Form Mobile
  // ------------------------------------
  orderParticipantFormMobile () {
    const collapseLink = $('.participant-form__title')
    const content = $('.participant-form__content')

    if (window.innerWidth > BREAKPOINT.TABLET) {
      collapseLink.removeAttr('data-toggle')
      if (content.hasClass('collapse')) {
        content.removeClass('collapse').css('height', 'auto')
      }
    } else {
      content.addClass('collapse')
      collapseLink.attr('data-toggle', 'collapse')
    }
  },
  orderParticipantMobileStyles () {
    const content = $('.participant-form__content')
    const title = $('.participant-form__title')

    if (window.innerWidth <= BREAKPOINT.TABLET) {
      title.on('click', function() {
        $(this).toggleClass('active-form')
        content.children().show()
        if (title.hasClass('active-form')) {
          $(this).find('.fa').removeClass('fa-sort-desc').addClass('fa-sort-asc')
        } else {
          $(this).find('.fa').removeClass('fa-sort-asc').addClass('fa-sort-desc')
        }
      })
    } else {
      title.removeClass('active-form')
      content.children().show()
    }
  },
  orderFixedHeader () {
    const headerO = $('.header--order')

    if (headerO.exists()) {
      if (window.innerWidth < BREAKPOINT.TABLET) {
        headerO.addClass('fixed')
      } else {
        headerO.removeClass('fixed')
      }
    }
  },

  // ------------------------------------
  // voucher on payment summary
  // ------------------------------------
  orderClearVoucherValue () {
    const input = $('.payment-summary__info').find('input[type="text"]')
    const closeBtn = $('.payment-summary__info').find('[class^="custom-icon--"]')

    input.keyup(function() {
      closeBtn.show()
    })
    closeBtn.on('click', function() {
      input.val(' ')
      $(this).hide()
    })
  },

  // ------------------------------------
  // order sidebar margin-top
  // ------------------------------------
  orderOfferMarginTop () {
    const offerOrder = $('.order-offer')
    const offerOrderParent = offerOrder.parent('.col-sm-5')
    offerOrder.addClass('sidebar-top')
    offerOrderParent.addClass('payment-widget__parent')
  },

  // ------------------------------------
  // show div with payment logos on choosing payment radio
  // ------------------------------------
  orderShowPaymentOptions () {
    const input = $('.payment-radio').find('input[type="radio"]')

    input.click(function() {
      if ($(this).val() == 'PŁATNOŚĆ KARTĄ') {
        if ($('.logo-radio').is(':visible'))
          $('.logo-radio').fadeOut(100)
        return
      }

      if ($('.logo-radio').is(':visible') == false) {
        $('.logo-radio').slideDown()
      }
    })
  },

  // -------------------------------------
  // Participant form - get the label value and put in in placeholder
  // -------------------------------------
  orderRadioValueParticipantForm () {
    const participantF = $('.participant-form')
    const inputForm = participantF.find('.order-input')
    const inputFormBtn = inputForm.find('.btn-group')
    const inputFormMenu = inputFormBtn.find('.dropdown-menu')

    inputFormMenu.find('.sex-radio').find('label').on('click', function() {
      const value = $.trim($(this).html())

      $(this).siblings('input').prop('checked', true)
      $(this).closest('.dropdown-menu').siblings('.dropdown-sex').html(value).addClass('chosen')
    })
  },

  agreementsModal () {
    const root = document.querySelector('.payment-agreement__content')
    const button = root.querySelector('a[title="regulamin"]')
    const config = { 
      url: URL_API.pageAgreements,
      modalHeadline: 'Regulamin strony',
    }

    button.addEventListener('click', e => {
      e.preventDefault()
      modalComponent.init(config)
    })
  },

  shouldInitRodoRegulations () {
    return document.querySelector('.payment-agreement__content') && document.querySelector('.rodo-regulations')
  },

  createRodoRegulationsPlaceholder () {
    const root = document.querySelector('.payment-agreement__content')
    const div = document.createElement('div')
    root.insertAdjacentElement('beforeend', div)
    return div
  },

  rodoRegulations () {
    if (this.shouldInitRodoRegulations()) {
      getAgreementsRegulation().then(data => {
        new RodoRegulations({ 
          el: this.createRodoRegulationsPlaceholder(),
          propsData: {
            preamble: data.preamble,
            body: data.body,
          },
        })
      })
    }
  },
}

module.exports = appGrecosPageOrder



// WEBPACK FOOTER //
// ./src/modules/appGrecosPageOrder.js